import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    ASSIGNMENT_DETAILS_GET_FAILURE: "ASSIGNMENT_DETAILS_GET_FAILURE",
    ASSIGNMENT_DETAILS_GET_REQUEST: "ASSIGNMENT_DETAILS_GET_REQUEST",
    ASSIGNMENT_DETAILS_GET_SUCCESS: "ASSIGNMENT_DETAILS_GET_SUCCESS",
    ASSIGNMENT_DETAILS_MERGE_SUCCESS: "ASSIGNMENT_DETAILS_MERGE_SUCCESS"
};

export const actionCreators = {
    getRequest: (auditId) => ({
        type: actionTypes.ASSIGNMENT_DETAILS_GET_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.ASSIGNMENT_DETAILS_GET_SUCCESS,
        [ERROR_ACTION]: actionTypes.ASSIGNMENT_DETAILS_GET_FAILURE,
        payload: { auditId }
    }),
    getSuccess: (assignmentDetails: any) => ({
        type: actionTypes.ASSIGNMENT_DETAILS_GET_SUCCESS,
        payload: { assignmentDetails }
    }),
    getFailure: (error: Error) => ({
        type: actionTypes.ASSIGNMENT_DETAILS_GET_FAILURE,
        error
    }),
    merge: (assignmentDetails) => ({
        type: actionTypes.ASSIGNMENT_DETAILS_MERGE_SUCCESS,
        payload: { assignmentDetails }
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
